import { Icon } from '../Icon';
import type { IconProps } from '../types';

export function ChevronDownIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M12.707 15.707a1 1 0 0 1-1.414 0l-6-6a1 1 0 0 1 1.414-1.414L12 13.586l5.293-5.293a1 1 0 0 1 1.414 1.414z" />
    </Icon>
  );
}

ChevronDownIcon.displayName = 'ChevronDownIcon';
